/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  Compliance,
  CompliancesDefectAnalyticsRetrieveParams,
  CompliancesListParams,
  DefectAnalytics,
  PaginatedComplianceList
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type compliancesListResponse200 = {
  data: PaginatedComplianceList
  status: 200
}

export type compliancesListResponseSuccess = (compliancesListResponse200) & {
  headers: Headers;
};
;

export type compliancesListResponse = (compliancesListResponseSuccess)

export const getCompliancesListUrl = (params?: CompliancesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["portfolio","region","service_provider"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/compliances/?${stringifiedParams}` : `/api/v1/compliances/`
}

export const compliancesList = async (params?: CompliancesListParams, options?: RequestInit): Promise<compliancesListResponse> => {

  return customFetch<compliancesListResponse>(getCompliancesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type compliancesRetrieveResponse200 = {
  data: Compliance
  status: 200
}

export type compliancesRetrieveResponseSuccess = (compliancesRetrieveResponse200) & {
  headers: Headers;
};
;

export type compliancesRetrieveResponse = (compliancesRetrieveResponseSuccess)

export const getCompliancesRetrieveUrl = (id: string,) => {




  return `/api/v1/compliances/${id}/`
}

export const compliancesRetrieve = async (id: string, options?: RequestInit): Promise<compliancesRetrieveResponse> => {

  return customFetch<compliancesRetrieveResponse>(getCompliancesRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type compliancesDefectAnalyticsRetrieveResponse200 = {
  data: DefectAnalytics
  status: 200
}

export type compliancesDefectAnalyticsRetrieveResponseSuccess = (compliancesDefectAnalyticsRetrieveResponse200) & {
  headers: Headers;
};
;

export type compliancesDefectAnalyticsRetrieveResponse = (compliancesDefectAnalyticsRetrieveResponseSuccess)

export const getCompliancesDefectAnalyticsRetrieveUrl = (params?: CompliancesDefectAnalyticsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["portfolio","region","service_provider"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/compliances/defect-analytics/?${stringifiedParams}` : `/api/v1/compliances/defect-analytics/`
}

/**
 * Aggregated defect analytics over the same scoped, filtered lifts the compliance list returns: a 12-month opened/closed series, open defects by category, and open defects due in the next 90 days.
 */
export const compliancesDefectAnalyticsRetrieve = async (params?: CompliancesDefectAnalyticsRetrieveParams, options?: RequestInit): Promise<compliancesDefectAnalyticsRetrieveResponse> => {

  return customFetch<compliancesDefectAnalyticsRetrieveResponse>(getCompliancesDefectAnalyticsRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


